function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInstallMac = function SvgInstallMac(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 236 125",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEEF1"
    },
    d: "M6,0h224c3.314,0,6,2.686,6,6v113c0,3.314-2.686,6-6,6H6c-3.314,0-6-2.686-6-6V6C0,2.686,2.686,0,6,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8BCCE"
    },
    d: "M0,6c0-3.314,2.686-6,6-6h224c3.314,0,6,2.686,6,6v10H0V6z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F37171"
    },
    cx: 11.5,
    cy: 8.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECE30F"
    },
    cx: 23.5,
    cy: 8.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#37C7A6"
    },
    cx: 35.5,
    cy: 8.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5650D7"
    },
    d: "M84.657,80.723v-1.156H84.25v-0.171h1.013v0.171h-0.407v1.156H84.657z M85.495,80.723v-1.328h0.264 l0.37,1.069l0.37-1.069h0.264v1.328h-0.199v-1.008l-0.37,1.008h-0.167l-0.37-1.008v1.008H85.495z M71.502,83.151 C61.289,83.142,53.009,74.913,53,64.765c0-1.559,1.272-2.822,2.84-2.822s2.84,1.263,2.84,2.826c0,7.035,5.74,12.739,12.817,12.739 S84.32,71.8,84.32,64.765c0-1.559,1.272-2.826,2.84-2.826S90,63.201,90,64.765C89.995,74.913,81.716,83.142,71.502,83.151 L71.502,83.151L71.502,83.151z M71.502,75.681c-6.069,0-10.986-4.889-10.986-10.916c0-6.027,4.917-10.916,10.986-10.916 s10.986,4.889,10.986,10.916C82.483,70.792,77.566,75.677,71.502,75.681z M71.502,55.375c-5.222,0-9.455,4.209-9.455,9.399 s4.232,9.395,9.455,9.395c5.222,0,9.455-4.205,9.455-9.395c-0.005-5.19-4.232-9.395-9.455-9.404V55.375L71.502,55.375z  M64.111,64.765h14.788c0,2.623-1.411,5.051-3.696,6.365c-2.285,1.314-5.107,1.314-7.392,0 C65.517,69.816,64.111,67.392,64.111,64.765L64.111,64.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#445B7D"
    },
    d: "M118.276,60.488l-0.751,0.773c-0.178,0.183-0.178,0.48,0,0.663l5.886,6.06h-12.956 c-0.251,0-0.455,0.21-0.455,0.469v1.094c0,0.259,0.204,0.469,0.455,0.469h12.956l-5.886,6.06c-0.178,0.183-0.178,0.48,0,0.663 l0.751,0.773c0.178,0.183,0.466,0.183,0.644,0l7.947-8.18c0.177-0.183,0.177-0.48,0-0.663l-7.947-8.18 C118.742,60.305,118.454,60.305,118.276,60.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97DDFF"
    },
    d: "M148.893,52.373h9.305c1.57-0.082,1.858,0.594,2.278,1.087l1.472,1.856 c0.12,0.15,0.235,0.205,0.489,0.204h23.669c1.178,0,1.893,0.793,1.893,1.893V83.64c0,0.55-0.443,0.994-0.994,0.994h-39.013 c-0.55,0-0.994-0.443-0.994-0.994V54.266C147,53.245,147.767,52.373,148.893,52.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CAF8"
    },
    d: "M148.893,57.544h37.214c1.178,0,1.893,0.793,1.893,1.893V83.64 c0,0.55-0.443,0.994-0.994,0.994h-39.013c-0.55,0-0.994-0.443-0.994-0.994V59.437C147,58.416,147.767,57.544,148.893,57.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0DEFA"
    },
    d: "M148.83,82.333h37.339v0.314H148.83V82.333z M148.83,81.321h37.339v0.314H148.83V81.321z  M148.83,80.309h37.339v0.314H148.83V80.309z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstallMac, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/installMac.e83cbd18.svg";
export { ForwardRef as ReactComponent };